const styleSheet = (theme: any) => ({
  backgroundContainer: {
    backgroundColor: '#FFFFFF',
    position: 'relative',
    paddingLeft: '48.5px',
  },
  loader: {
    width: '987px',
    height: '100%',
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    zIndex: 9,
  },
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/dashboards/ContentPerformanceOverview/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/containers/GoodData/dashboards/ContentPerformanceOverview/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }